export default __webpack_public_path__ + "static/media/bg.41a5e603.png";